// application
import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import {
  ManufacturerRequest,
  VehicleFiltersRequest
} from '@/main/models/request';

export abstract class IManufacturerApi {
  abstract getVehicleManufacturer(
    request: ManufacturerRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getVehicleManufacturerByFilters(
    request: VehicleFiltersRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
